import React from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { useVacancyByCampaignId } from '@/hooks/queries/usevacancy';
import Loader from '@/components/Loader';

const CampaignVacancies = () => {
  const { campaignId } = useParams();
  const navigate = useNavigate();

  // Fetch vacancies for the campaign from API
  const { data: vacancies = [], isLoading, isError } = useVacancyByCampaignId(campaignId);

  if (isLoading) return <Loader />;
  if (isError) return <div>Error loading vacancies</div>;

  return (
    <div className="w-full p-6">
      <h2 className="text-xl font-semibold mb-4">Vacancies</h2>
      {vacancies?.vacancies?.length > 0 ? (
        <div className="overflow-x-auto bg-card rounded-lg shadow">
          <table className="min-w-full divide-y divide-border">
            <thead className="bg-muted">
              <tr>
                <th className="px-6 py-3 text-left text-xs font-medium text-muted-foreground uppercase tracking-wider">
                  Title
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-muted-foreground uppercase tracking-wider">
                  Status
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-muted-foreground uppercase tracking-wider">
                  Applications
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-muted-foreground uppercase tracking-wider">
                  Actions
                </th>
              </tr>
            </thead>
            <tbody className="bg-card divide-y divide-border">
              {vacancies.vacancies.map(vacancy => (
                <tr key={vacancy.id} className="hover:bg-muted">
                  <td className="px-6 py-4 whitespace-nowrap">
                    <div className="text-sm font-medium text-foreground">
                      {vacancy.title}
                    </div>
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap">
                    <span className={`px-2 inline-flex text-xs leading-5 font-semibold rounded-full ${vacancy.status === 'Active' ? 'bg-green-100 text-green-800' : 'bg-red-100 text-red-800'}`}>
                      {vacancy.status}
                    </span>
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap text-sm text-muted-foreground">
                    {vacancy.applications}
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap text-sm font-medium">
                    <button
                      className="text-primary hover:text-primary-dark mx-2"
                      onClick={() => navigate(`/vacancies/view/${vacancy.id}`)}
                    >
                      View
                    </button>
                    <button
                      className="text-primary hover:text-primary-dark mx-2"
                      onClick={() => navigate(`/campaigns/${campaignId}/vacancies/${vacancy.id}`)}
                    >
                      Edit
                    </button>
                    <button
                      className="text-red-600 hover:text-red-800 mx-2"
                      onClick={() => navigate(`/campaigns/${campaignId}/vacancies/${vacancy.id}/delete`)}
                    >
                      Delete
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      ) : (
        <p className="text-muted-foreground">No vacancies found for this campaign.</p>
      )}
    </div>
  );
};

export default CampaignVacancies;